/* Monsieur Carpe : lecteur YouTube chargé au clic (assets/mc-video.js), v1.0 du 07/10/2026.
   Cible : tout bloc <div class="mc-video" data-yt="ID"> (corps d'article, fiches, comparatifs).
   Avant le clic : aucun appel vers YouTube, aucune image distante. Au clic : iframe youtube-nocookie.com. */
(function () {
  function monter(el) {
    var id = el.getAttribute('data-yt') || '';
    if (!/^[A-Za-z0-9_-]{6,20}$/.test(id) || el.querySelector('.mc-video__jouer, .mc-video__cadre')) return;
    var t = el.querySelector('.mc-video__titre');
    var titre = t ? t.textContent.trim() : 'Vidéo';
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'mc-video__jouer';
    b.setAttribute('aria-label', 'Lire la vidéo ici : ' + titre);
    b.innerHTML = '<span class="mc-video__icone" aria-hidden="true">&#9654;</span><span>Lire la vidéo ici</span><small>Le lecteur YouTube ne se charge qu’au clic.</small>';
    b.addEventListener('click', function () {
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
      f.title = titre;
      f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      f.allowFullscreen = true;
      f.referrerPolicy = 'strict-origin-when-cross-origin';
      var w = document.createElement('div');
      w.className = 'mc-video__cadre';
      w.appendChild(f);
      b.parentNode.replaceChild(w, b);
      f.focus();
    });
    var lien = el.querySelector('.mc-video__lien');
    el.insertBefore(b, lien || null);
  }
  function init() { document.querySelectorAll('.mc-video[data-yt]').forEach(monter); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
